import type { InvoiceType, PaymentMethod } from '@/shared/domain'

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  deposit: 'Deposit',
  balance: 'Balance',
  full: 'Full',
}

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: 'Cash',
  check: 'Check',
  stripe: 'Stripe',
  other: 'Other',
}
